// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chipsclass[data-v-599f9867] {\n  max-width: 5rem;\n}\n.chipsclass span[data-v-599f9867] {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--box .v-select__selections[data-v-599f9867], .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed .v-select__selections[data-v-599f9867] {\n  min-height: unset !important;\n}\n", ""]);
// Exports
module.exports = exports;
